// extracted by mini-css-extract-plugin
export default {"wrapper":"EntryModuleWrapper_wrapper__3uZA6"};